import React, { useRef } from 'react';
import classNames from 'classnames';
import moment from 'moment/moment';
import { toJpeg } from 'html-to-image';
import download from 'downloadjs';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogClose, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';

import { optionClassFormatter } from '../../../utils/formatters';
import { Button } from '../../../components/base/BootstrapComponents';
import { CAMERA_STATUS } from '../constants';
import notificationDecorator from '../../Notifications/notificationDecorator';

export default function MatrixReportPopup(props) {
  const intl = useIntl();
  const { formatMessage } = intl;
  const matrixReportRef = useRef(null);
  const { handleClose = () => {}, sortedHostStatusesList } = props;
  const currentDate = moment().format('DD.MM.YY HH:mm');
  const goodStatuses = sortedHostStatusesList.filter(i => i.status === CAMERA_STATUS.OK);
  const warningStatuses = sortedHostStatusesList.filter(i => i.status === CAMERA_STATUS.WARNING);
  const errorStatuses = sortedHostStatusesList.filter(i => i.status === CAMERA_STATUS.ERROR);
  const reportShortList = sortedHostStatusesList.slice(0, 150);
  const saveMatrixReport = opts => {
    if (!matrixReportRef || !matrixReportRef.current) {
      return null;
    }
    toJpeg(matrixReportRef.current)
      .then(dataUrl => {
        download(dataUrl, `Состояние видеокамер на ${currentDate}.jpg`);
        notificationDecorator(
          {
            title: 'Формирование отчета',
            message: formatMessage({ id: 'success' }),
          },
        );
      })
      .catch(error => {
        notificationDecorator(
          {
            title: 'Формирование отчета',
            message: formatMessage({ id: 'failed' }),
            isError: true,
          },
        );
        window.console.error('Generate image wrong!', error);
      });
  };

  return (
    <Dialog
      onClose={handleClose}
      open
      className="matrix-report-popup"
      size="xl"
    >
      <DialogTitle header="Формирование отчета" title={<DialogClose onClick={handleClose} />} />
      <DialogContent>
        <div className="matrix-report" ref={matrixReportRef}>
          <div className="matrix-report-header">
            <div className="matrix-report-title">Состояние видеокамер на {currentDate}</div>
            <div className="matrix-report-legend">
              <div className="matrix-report-legend-state mrls-error">
                <div className="mrls-icon" />
                <div className="mrls-text f7">{errorStatuses.length} шт</div>
              </div>
              <div className="matrix-report-legend-state mrls-warning">
                <div className="mrls-icon" />
                <div className="mrls-text f7">{warningStatuses.length} шт</div>
              </div>
              <div className="matrix-report-legend-state mrls-good">
                <div className="mrls-icon" />
                <div className="mrls-text f7">{goodStatuses.length} шт</div>
              </div>
            </div>
          </div>
          <div className="matrix-wrapper report-matrix-wrapper">
            {reportShortList.map((item, key) => (
              <div key={key} className={classNames('matrix-element report', optionClassFormatter(item.status))}>
                {item.name}
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
      <DialogFooter className="matrix-report-footer">
        <div className="matrix-report-footer-buttons">
          <Button variant="secondary" onClick={saveMatrixReport}>Сохранить</Button>
          <Button onClick={handleClose}>Закрыть</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
